<template>
	<SignUpPageBase :content="this">
		<h4 class="font_lg font_bold margin_title_bottom">{{ $t("signUp.bankAccount.title") }}</h4>
		<span class="margin_vertical">{{ $t("signUp.bankAccount.text") }}</span>
		<form class="flex flex_center flex_column w_100">
			<md-field :class="[{ 'md-error': errors.has('bankAccountIban') }]">
				<label>{{ $t("common.iban") }}</label>
				<md-input
					v-model="form.bankAccountIban"
					v-validate="modelValidations.bankAccountIban"
					data-vv-name="bankAccountIban"
					required
				></md-input>
			</md-field>
			<md-field :class="[{ 'md-error': errors.has('bankAccountBic') }]">
				<label>{{ $t("common.bic") }}</label>
				<md-input
					v-model="form.bankAccountBic"
					v-validate="modelValidations.bankAccountBic"
					data-vv-name="bankAccountBic"
					required
				></md-input>
			</md-field>
			<CurrencySelect
				class="w_100"
				v-model="form.bankAccountCurrency"
				v-validate="modelValidations.bankAccountCurrency"
				data-vv-name="bankAccountCurrency"
				:error="errors.first('bankAccountCurrency')"
				:disabled="true"
				:required="true"
			></CurrencySelect>
			<!-- Disabled for now upon product request DEV-6716 -->
			<!--
			<div class="flex flex_start w_100">
				<md-checkbox
					class="padding_vertical"
					:class="[{ 'md-error': errors.has('directDebitCheck') }]"
					v-model="form.directDebitCheck"
					v-validate="modelValidations.directDebitCheck"
					data-vv-name="directDebitCheck"
					required
				></md-checkbox>
				<span>{{ $t("signUp.bankAccount.directDebitCheck") }} </span>
			</div>
			-->
		</form>
	</SignUpPageBase>
</template>

<script>
import SignUpPageBase from "@/views/register/SignUpPageBase";
import {mapGetters} from "vuex";
import CurrencySelect from "@/components/templates/select/CurrencySelect";
import {registrationApi} from "@/common/api/registrationApi";

export default {
	components: {
		CurrencySelect,
		SignUpPageBase
	},
	data() {
		return {
			form: {
				bankAccountIban: "",
				bankAccountBic: "",
				bankAccountCurrency: "",
				directDebitCheck: false
			},
			modelValidations: {
				bankAccountIban: {
					required: true
				},
				bankAccountBic: {
					required: true
				},
				bankAccountCurrency: {
					required: true
				},
				// Disabled for now upon product request DEV-6716
				/*directDebitCheck: {
					checked: true
				},*/
			}
		};
	},
	created() {
		this.$mergeOnlyExistingProps(this.form, this.signUpData, true);

		// Force EUR currency for fee account for now
		this.form.bankAccountCurrency = "EUR";
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData"
		})
	},
	methods: {
		changeBankData(data) {
			this.form = {
				...this.form,
				bankAccountIban: data.mainAccountIban,
				bankAccountBic: data.mainAccountBic,
				bankAccountCurrency: data.currency,
			}
		},
		validateData() {
			return registrationApi.checkBankAccount({
				...this.signUpData,
				...this.form
			});
		},
	},
};
</script>